import Vue from 'vue';
import VueInstance from '@/main';
import moment from 'moment';

// 空值过滤器
Vue.filter('emptyFilter', (value) => {
  return VueInstance.$isNotEmpty(value) ? value : '-';
});

// 时间显示
Vue.filter('TimeFormat', (value) => {
  if (value) {
    return moment(value).format('YYYY/MM/DD HH:mm:ss');
  }
  return '';
});

// 时间显示
Vue.filter('SimpleTimeFormat', (value) => {
  if (value) {
    return moment(value).format('YYYY/MM/DD');
  }
  return '';
});

Vue.filter('DateFormat', (value) => {
  if (value) {
    return moment(value).format('YYYY-MM-DD');
  }
  return '-';
});

// 时间显示
Vue.filter('HourMinutesFormat', (value) => {
  if (value) {
    return moment(value).format('HH:mm');
  }
  return '-';
});

Vue.prototype.$formatMoney = (value) => {
  if (value && value != null) {
    value = String(Math.round(value * 100) / 100);
    const left = value.split('.')[0];
    let right = value.split('.')[1];
    right = right
      ? right.length >= 2
        ? '.' + right.substr(0, 2)
        : '.' + right + '0'
      : '.00';
    const temp = left
      .split('')
      .reverse()
      .join('')
      .match(/(\d{1,3})/g);
    return (
      (Number(value) < 0 ? '-' : '') +
      temp.join(',').split('').reverse().join('') +
      right
    );
  } else if (value === 0) {
    return '0.00';
  } else {
    return '-';
  }
};

// 金额千分符
Vue.filter('MoneyFormat', (value) => {
  return value? value.toLocaleString() : (value === 0? 0 : '')
});

// 金额千分符
Vue.filter('MoneyFormatWithDefaultValue', (value) => {
  if (value && value != null) {
    value = String(Math.round(value * 100) / 100);
    const left = value.split('.')[0];
    let right = value.split('.')[1];
    right = right
      ? right.length >= 2
        ? '.' + right.substr(0, 2)
        : '.' + right + '0'
      : '.00';
    const temp = left
      .split('')
      .reverse()
      .join('')
      .match(/(\d{1,3})/g);
    return (
      (Number(value) < 0 ? '-' : '') +
      temp.join(',').split('').reverse().join('') +
      right
    );
  } else if (value === 0) {
    return '0.00';
  } else {
    return '-';
  }
});

Vue.filter('FileSizeFormat', (value) => {
  if (!value) return 0;
  let kb = 1024,
    mb = 1024 * 1024,
    gb = 1024 * 1024 * 1024;
  if (value > gb) {
    return (value / gb).toFixed(2) + 'G';
  } else if (value > mb) {
    return (value / mb).toFixed(2) + 'M';
  } else if (value > kb) {
    return (value / kb).toFixed(2) + 'K';
  } else {
    return value + 'B';
  }
});

// 获取文件后缀名
Vue.filter('FileSuffixName', (value) => {
  if (!value) return '';
  const arr = value.split('.');
  return arr[arr.length - 1];
});

// 后台返回时间处理成日期
Vue.filter('Time2Date', (value) => {
  if (!value) return '';
  let result = '';
  result = moment(value).format('YYYY/MM/DD');
  return result;
});

// 去掉html
Vue.filter('removeHtmlTag', (value) => {
  return value.replace(/<(style|script|iframe)[^>]*?>[\s\S]+?<\/\1\s*>/gi,'').replace(/<[^>]+?>/g,'').replace(/\s+/g,' ').replace(/ /g,' ').replace(/>/g,' ').replace(/&nbsp;/g,' ');
});



// WEBPACK FOOTER //
// ./src/filters.js